export function getPrintJobBlobUrl(data: any): string | null {
	if (!data) return null;
	try {
		const parsed = typeof data === "string" ? JSON.parse(data) : data;
		const base64 = parsed.Data ?? parsed.data;
		if (!base64) return null;

		const byteChars = atob(base64);
		const byteArray = new Uint8Array(byteChars.length);
		for (let i = 0; i < byteChars.length; i++) {
			byteArray[i] = byteChars.charCodeAt(i);
		}
		const blob = new Blob([byteArray], { type: "application/pdf" });
		return URL.createObjectURL(blob);
	} catch {
		return null;
	}
}

export function getPrintJobFileName(data: any): string {
	if (!data) return "Dokument";
	try {
		const parsed = typeof data === "string" ? JSON.parse(data) : data;
		return parsed.FileName ?? parsed.fileName ?? "Dokument";
	} catch {
		return "Dokument";
	}
}
